import { render } from "./support.vue?vue&type=template&id=5dad34f3&ts=true&lang=pug"
import script from "./support.vue?vue&type=script&lang=ts"
export * from "./support.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__